import Vue from 'vue';
import App from './App.vue';
import router from './router';
import '@/styles/styles.scss';
import Vuex from 'vuex';
import vuetify from '@/plugins/vuetify';
import i18n from './i18n';
import store from "./stores";
import Toast from 'vue-toastification';
import CustomNotifications from "@/plugins/CustomNotification.plugin";
import "vue-toastification/dist/index.css";
import FormattingPlugin from "@/plugins/Formatting.plugin";
import ErrorHandlerPlugin from "@/plugins/ErrorHandler.plugin";
import ScopeValidation from "@/plugins/ScopeValidation.plugin";
import {setOptions} from "@googlemaps/js-api-loader";

Vue.use(Vuex);
Vue.config.productionTip = false;

Vue.use(Toast, {});
Vue.use(CustomNotifications);
Vue.use(ErrorHandlerPlugin);
Vue.use(FormattingPlugin);
Vue.use(ScopeValidation);

setOptions({ key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app');
